export const LandingPageUtil = ( function() {
	
	var PAGE_LENGTH = 4,
		JACKET_MARGIN_LEFT = 20,
		JACKET_WIDTH_TO_HEIGHT_RATIO = 1.5,
		JACKET_BOX_SHADOW_WIDTH = 0,
		JACKET_BOX_SHADOW_DISTANCE = 2,
		JACKET_BOX_SHADOW_SPREAD = 3,
		TOTAL_MARGINS = (PAGE_LENGTH + 1) * JACKET_MARGIN_LEFT,
		TOTAL_SHADOW_WIDTH = (PAGE_LENGTH * 2) * JACKET_BOX_SHADOW_WIDTH;
		
		//TODO move all positioning logic and calculations in here and write unit tests for them
		
		var getNewJacketWidth = function(jacketContainerWidth) {
			var remainingSpace = jacketContainerWidth - (TOTAL_MARGINS + TOTAL_SHADOW_WIDTH);
			var jacketWidth = remainingSpace / PAGE_LENGTH;
			return jacketWidth;
		};
		
		var getWrapEndPosition = function(pageCount, jacketWidth){
			return (pageCount*(JACKET_MARGIN_LEFT+JACKET_BOX_SHADOW_WIDTH+jacketWidth))+JACKET_MARGIN_LEFT;
		};
		
		var getWrapStartPosition = function(pageCount, jacketWidth, jacketContainerWidth){//TODO depends on the direction
			return getWrapEndPosition(pageCount, jacketWidth)+jacketContainerWidth;
		};

		return {
			getPrevWrapPosition: function(pageCount, jacketContainerWidth){
				var jacketWidth = getNewJacketWidth(jacketContainerWidth),
					firstPageEnd = getWrapEndPosition(pageCount, jacketWidth);
				return {
					firstPage: {
						start: -1,
						end: firstPageEnd
					},
					prevPage: {
						start: -firstPageEnd,
						end: 0
					}
				};
			},
			getWrapPosition: function(pageCount, jacketContainerWidth){
				var jacketWidth = getNewJacketWidth(jacketContainerWidth);
				return {
					start: getWrapStartPosition(pageCount, jacketWidth, jacketContainerWidth),
					end: getWrapEndPosition(pageCount, jacketWidth)
				};
			},
			getAdjustedDirection: function(pageCount, jacketContainerWidth){
				var jacketWidth = getNewJacketWidth(jacketContainerWidth);
				return getWrapEndPosition(pageCount, jacketWidth);
			},
			getResizeDimensions: function(jacketContainerWidth){
				var jacketWidth = getNewJacketWidth(jacketContainerWidth, PAGE_LENGTH),
					jacketHeight = Math.ceil(jacketWidth * JACKET_WIDTH_TO_HEIGHT_RATIO);
				
				return {
					jacketWidth: jacketWidth,
					jacketHeight: jacketHeight,
					marginLeft: JACKET_MARGIN_LEFT,
					pageWidth: jacketContainerWidth,
					pageHeight: jacketHeight + JACKET_BOX_SHADOW_DISTANCE + JACKET_BOX_SHADOW_SPREAD,
					pageLength: PAGE_LENGTH
				};
			},
			getImageDimensions : function(realWidth, realHeight, maxWidth, maxHeight, minMatte) {
				var targetWidth = maxWidth - (minMatte * 2), targetHeight = maxHeight - (minMatte * 2), returnObj = {
					height : targetHeight,
					marginTop : minMatte,
					width : realWidth,
					marginLeft : minMatte,
					marginRight : minMatte,
					marginBottom : minMatte
				};

				if (realWidth > targetWidth) {
					returnObj.width = targetWidth;
					realHeight = realHeight * (targetWidth / realWidth);
					//scale down height
				}
				if (realHeight > targetHeight) {
					returnObj.width = (targetHeight / realHeight) * returnObj.width;
				} else if (realHeight < targetHeight) {
					returnObj.height = realHeight;
					const splitDiff = ((targetHeight - realHeight) / 2);
					returnObj.marginTop = splitDiff + minMatte;
					returnObj.marginBottom = splitDiff + minMatte;
				}
				if (targetWidth > returnObj.width) {
					const splitDiff = ((targetWidth - returnObj.width) / 2);
					returnObj.marginLeft = splitDiff + minMatte;
					returnObj.marginRight = splitDiff + minMatte;
				}
				return returnObj;
			}
		}

	}());
